module.exports = __webpack_public_path__ + "media/images/proof_links/colored/youtube-8eeda1aee992c415a4de57396653e3c9.svg";